var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _vm.checkPermi(["merchant:workOrder:page:list"])
        ? _c(
            "el-card",
            {
              staticClass: "ivu-mt",
              attrs: {
                bordered: false,
                shadow: "never",
                "body-style": { padding: 0 },
              },
            },
            [
              _c(
                "div",
                { staticClass: "padding-add" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: { inline: "", "label-position": "right" },
                      nativeOn: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "工单编号：", "label-width": "66px" },
                        },
                        [
                          _c("el-input", {
                            staticClass: "form_content_width",
                            attrs: {
                              placeholder: "请输入工单号",
                              size: "small",
                              clearable: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleSearchList($event)
                              },
                            },
                            model: {
                              value: _vm.tableFrom.workOrderNo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.tableFrom,
                                  "workOrderNo",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "tableFrom.workOrderNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "订单编号：", "label-width": "66px" },
                        },
                        [
                          _c("el-input", {
                            staticClass: "form_content_width",
                            attrs: {
                              placeholder: "请输入订单号",
                              size: "small",
                              clearable: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleSearchList($event)
                              },
                            },
                            model: {
                              value: _vm.tableFrom.orderNo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.tableFrom,
                                  "orderNo",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "tableFrom.orderNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "预约类型：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "form_content_width",
                              attrs: {
                                clearable: "",
                                size: "small",
                                placeholder: "请选择",
                              },
                              on: { change: _vm.handleSearchList },
                              model: {
                                value: _vm.tableFrom.serviceType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.tableFrom, "serviceType", $$v)
                                },
                                expression: "tableFrom.serviceType",
                              },
                            },
                            _vm._l(_vm.fromType, function (item, i) {
                              return _c("el-option", {
                                key: i,
                                attrs: { label: item.text, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "时间选择：" } },
                        [
                          _c("el-date-picker", {
                            staticClass: "form_content_width",
                            attrs: {
                              "value-format": "yyyy-MM-dd",
                              format: "yyyy-MM-dd",
                              size: "small",
                              type: "daterange",
                              placement: "bottom-end",
                              placeholder: "自定义时间",
                            },
                            on: { change: _vm.onchangeTime },
                            model: {
                              value: _vm.timeVal,
                              callback: function ($$v) {
                                _vm.timeVal = $$v
                              },
                              expression: "timeVal",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "用户搜索：",
                            "label-for": "nickname",
                          },
                        },
                        [
                          _c("UserSearchInput", {
                            model: {
                              value: _vm.tableFrom,
                              callback: function ($$v) {
                                _vm.tableFrom = $$v
                              },
                              expression: "tableFrom",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "small" },
                              on: { click: _vm.handleSearchList },
                            },
                            [_vm._v("查询")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: { click: _vm.handleReset },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm.checkPermi([
        "merchant:workOrder:status:num",
        "merchant:workOrder:page:list",
      ])
        ? _c(
            "el-card",
            {
              staticClass: "box-card mt16",
              attrs: {
                shadow: "never",
                bordered: false,
                "body-style": { padding: "0 20px 20px", position: "relative" },
              },
            },
            [
              _c(
                "el-tabs",
                {
                  staticClass: "list-tabs",
                  on: { "tab-click": _vm.handleSearchList },
                  model: {
                    value: _vm.tableFrom.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.tableFrom, "status", $$v)
                    },
                    expression: "tableFrom.status",
                  },
                },
                [
                  _c("el-tab-pane", {
                    attrs: {
                      name: "0",
                      label: "全部(" + (_vm.orderChartType.all || 0) + ")",
                    },
                  }),
                  _c("el-tab-pane", {
                    attrs: {
                      name: "1",
                      label:
                        "待领取(" + (_vm.orderChartType.unReceive || 0) + ")",
                    },
                  }),
                  _c("el-tab-pane", {
                    attrs: {
                      name: "2",
                      label:
                        "已领取(" + (_vm.orderChartType.received || 0) + ")",
                    },
                  }),
                  _c("el-tab-pane", {
                    attrs: {
                      name: "3",
                      label:
                        "服务中(" + (_vm.orderChartType.inService || 0) + ")",
                    },
                  }),
                  _c("el-tab-pane", {
                    attrs: {
                      name: "4",
                      label:
                        "服务结束(" +
                        (_vm.orderChartType.endService || 0) +
                        ")",
                    },
                  }),
                  _c("el-tab-pane", {
                    attrs: {
                      name: "9",
                      label:
                        "已退款(" + (_vm.orderChartType.refunded || 0) + ")",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "mt5" },
                [
                  _c(
                    "el-dropdown",
                    { attrs: { size: "small" } },
                    [
                      _c(
                        "el-button",
                        {
                          class: _vm.checkedIds.length > 0 ? "" : "active",
                          attrs: { disabled: _vm.isBatch },
                        },
                        [
                          _vm._v(" 批量设置"),
                          _c("i", {
                            staticClass: "el-icon-arrow-down el-icon--right",
                          }),
                        ]
                      ),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          [
                            _vm.tableFrom.status == 1 &&
                            _vm.checkPermi(["merchant:workOrder:assign"]) &&
                            _vm.checkedIds.length > 0
                              ? _c(
                                  "el-dropdown-item",
                                  {
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.handleDispatch(1)
                                      },
                                    },
                                  },
                                  [_vm._v("派单")]
                                )
                              : _vm._e(),
                            _vm.dispatch
                              ? _c(
                                  "el-dropdown-item",
                                  {
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.handleDispatch(2)
                                      },
                                    },
                                  },
                                  [_vm._v("改派")]
                                )
                              : _vm._e(),
                            _vm.rescheduling
                              ? _c(
                                  "el-dropdown-item",
                                  {
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.handleRescheduling($event)
                                      },
                                    },
                                  },
                                  [_vm._v("改约")]
                                )
                              : _vm._e(),
                          ],
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  staticClass: "mt20",
                  attrs: {
                    data: _vm.tableData.data,
                    size: "mini",
                    "highlight-current-row": "",
                    "highlight-current-row": true,
                  },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "55" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "工单号", "min-width": "190" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "acea-row" }, [
                                _c("span", {
                                  staticStyle: { display: "block" },
                                  domProps: {
                                    textContent: _vm._s(scope.row.workOrderNo),
                                  },
                                }),
                              ]),
                              _c("div", { staticClass: "flex" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          parseInt(scope.row.refundStatus) > 0,
                                        expression:
                                          "parseInt(scope.row.refundStatus) > 0",
                                      },
                                    ],
                                    staticClass: "colorPrompt",
                                    staticStyle: { display: "block" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.refundStatus === 1
                                          ? "退款审核中"
                                          : "已退款"
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: scope.row.isUserDel,
                                      expression: "scope.row.isUserDel",
                                    },
                                  ],
                                  staticClass: "colorPrompt",
                                  staticStyle: { display: "block" },
                                },
                                [_vm._v("用户已删除")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1305409739
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "orderNo",
                      label: "订单号",
                      "min-width": "190",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "userPhone",
                      label: "服务类型",
                      "min-width": "80",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    scope.row.serviceType === 1
                                      ? "上门服务"
                                      : "到店服务"
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      222211572
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "服务状态", "min-width": "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.refundStatus === 0
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "statusBox",
                                      style: {
                                        color: _vm.orderColorFilter(
                                          scope.row.serviceStatus
                                        ),
                                        borderColor: _vm.orderColorFilter(
                                          scope.row.serviceStatus
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("serviceStatusFilter")(
                                              scope.row.serviceStatus
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "span",
                                    { staticClass: "statusBox notStartTag" },
                                    [_vm._v("已退款")]
                                  ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      850992564
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "预约时间", "min-width": "160" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  " " + _vm._s(scope.row.reservationDate) + " "
                                ),
                              ]),
                              _c("span", { staticClass: "ml10" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(scope.row.reservationTimeSlot) +
                                    " "
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2236668183
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "预约人名称",
                      "min-width": "150",
                      prop: "userName",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "userPhone",
                      label: "预约人电话",
                      "min-width": "120",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "userAddress",
                      label: "预约地址",
                      "min-width": "200",
                      "show-overflow-tooltip": true,
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { width: "185", fixed: "right", label: "操作" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm.checkPermi(["merchant:workOrder:detail"])
                                ? _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.onOrderDetails(
                                            scope.row.workOrderNo
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("详情 ")]
                                  )
                                : _vm._e(),
                              scope.row.groupBuyRecordStatus != 0
                                ? _c("el-divider", {
                                    attrs: { direction: "vertical" },
                                  })
                                : _vm._e(),
                              _vm.checkPermi(["merchant:workOrder:mark"])
                                ? _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleOrderMark(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("工单备注 ")]
                                  )
                                : _vm._e(),
                              scope.row.serviceStatus === 3 &&
                              _vm.checkPermi([
                                "merchant:workOrder:forceFinish",
                              ]) &&
                              scope.row.refundStatus === 0
                                ? [
                                    _c("el-divider", {
                                      attrs: { direction: "vertical" },
                                    }),
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleForceFinish(
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("完成工单 ")]
                                    ),
                                  ]
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      999414938
                    ),
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "block" },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      "page-sizes": _vm.$constants.page.limit,
                      "page-size": _vm.tableFrom.limit,
                      "current-page": _vm.tableFrom.page,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.tableData.total,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.pageChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("dialogDispatch", {
        ref: "dialogDispatchRef",
        attrs: { workOrderNoList: _vm.checkedIds },
        on: { selectStaff: _vm.handleSearchList },
      }),
      _c("dialogReschedule", {
        ref: "dialogRescheduleRef",
        attrs: { workOrderNoList: _vm.checkedIds, isBatch: true },
        on: { selectStaff: _vm.handleSearchList },
      }),
      _c("details-from", {
        ref: "orderDetail",
        attrs: { workOrderNo: _vm.workOrderNo },
        on: { changeStaff: _vm.handleSearchList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }